import ShortcutTileSelfcare from 'components/shared/ShortcutTileSelfcare'
import showDetails from 'assets/icons/shortcut_showDetails.svg'
import { scrollTo } from 'helpers/animateScroll'
//import changeDate from 'assets/icons/shortcut_changeDate.svg'
import editReservation from 'assets/icons/shortcut_editReservation.svg'
import cancelStay from 'assets/icons/shortcut_cancelStay.svg'
import Box from 'components/shared/Box'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { useApp } from 'store/steps'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import CancelYourVisitModal from 'routes/selfcare/modals/CancelYourVisitModal'
import { setIsCancelYourVisitModalOpen } from 'store/general-slice'

const ShortcutTiles = () => {
    const { formatMessage } = useIntl()
    const navigate = useNavigate()
    const { getPath } = useApp()
    const { isRevertLoading } = useAppSelector((state) => state.selfcare)
    const dispatch = useAppDispatch()

    return (
        <Box direction={['column', 'row']} gap={[16, 30]} pb={16}>
            <ShortcutTileSelfcare
                text={formatMessage({
                    id: 'selfcare.summary.shortcut_show_details',
                    defaultMessage: 'Pokaż szczegóły rezerwacji',
                })}
                alt="Show details icon"
                icon={showDetails}
                onClick={() =>
                    scrollTo({
                        id: 'reservation_details',
                        duration: 500,
                    })
                }
                testId="selfcare-shortcut-button-details"
            />
            {/* TODO: module disabled: GLOBAL DATE CHANGE */}
            {/*<ShortcutTileSelfcare
                text={formatMessage({
                    id: 'selfcare.summary.shortcut_change_dates',
                    defaultMessage: 'Zmień datę pobytu',
                })}
                alt="Change dates icon"
                icon={changeDate}
                onClick={() => navigate(getPath('edit_order'))}
            />*/}
            <ShortcutTileSelfcare
                text={formatMessage({
                    id: 'selfcare.summary.shortcut_edit_reservation',
                    defaultMessage: 'Edytuj rezerwację',
                })}
                alt="Edit reservation icon"
                icon={editReservation}
                onClick={() =>
                    !isRevertLoading && navigate(getPath('edit_order'))
                }
                testId="selfcare-shortcut-button-edit"
            />

            <ShortcutTileSelfcare
                text={formatMessage({
                    id: 'selfcare.summary.shortcut_cancel_stay',
                    defaultMessage: 'Anuluj pobyt',
                })}
                alt="Cancel reservation icon"
                icon={cancelStay}
                onClick={() => dispatch(setIsCancelYourVisitModalOpen(true))}
                testId="selfcare-shortcut-button-cancel"
            />
            <CancelYourVisitModal />
        </Box>
    )
}

export default ShortcutTiles
